export default __webpack_public_path__ + "static/perfect-pair.dark-1cc6eda3af4c2faa7120d71492bbbae7.png";